import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Teacher\AvailabilityController::index
* @see app/Http/Controllers/Teacher/AvailabilityController.php:17
* @route '/teacher/availability'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/teacher/availability',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\AvailabilityController::index
* @see app/Http/Controllers/Teacher/AvailabilityController.php:17
* @route '/teacher/availability'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\AvailabilityController::index
* @see app/Http/Controllers/Teacher/AvailabilityController.php:17
* @route '/teacher/availability'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\AvailabilityController::index
* @see app/Http/Controllers/Teacher/AvailabilityController.php:17
* @route '/teacher/availability'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\AvailabilityController::store
* @see app/Http/Controllers/Teacher/AvailabilityController.php:33
* @route '/teacher/availability'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/teacher/availability',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\AvailabilityController::store
* @see app/Http/Controllers/Teacher/AvailabilityController.php:33
* @route '/teacher/availability'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\AvailabilityController::store
* @see app/Http/Controllers/Teacher/AvailabilityController.php:33
* @route '/teacher/availability'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Teacher\AvailabilityController::destroy
* @see app/Http/Controllers/Teacher/AvailabilityController.php:60
* @route '/teacher/availability'
*/
export const destroy = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/teacher/availability',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Teacher\AvailabilityController::destroy
* @see app/Http/Controllers/Teacher/AvailabilityController.php:60
* @route '/teacher/availability'
*/
destroy.url = (options?: RouteQueryOptions) => {
    return destroy.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\AvailabilityController::destroy
* @see app/Http/Controllers/Teacher/AvailabilityController.php:60
* @route '/teacher/availability'
*/
destroy.delete = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(options),
    method: 'delete',
})

const availability = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    destroy: Object.assign(destroy, destroy),
}

export default availability